export default function menuTabs() {
    if (document.querySelectorAll('.menu-tab >li')) {
        let tabs = document.querySelectorAll('.menu-tab >li');
        let current = null;

        tabs.forEach(function (item, index) {
            let menuContent = item.querySelector('.submenu-tab-content');
       
            item.addEventListener('click', function (event) {
                if(screen.width >= 1200){
                    if (current && current != item){
                        current.classList.remove('is-active');
                    }
                    current = item;
                    item.classList.toggle('is-active');
                } else{
                    if(!event.target.classList.contains('js-tab-back')){
                        event.preventDefault();
                        menuContent.classList.add('is-active');
                    }
                }
            });

            if(item.querySelector('.js-tab-back')) {
                item.querySelector('.js-tab-back').addEventListener('click', function (event) {
                    event.preventDefault();
                    menuContent.classList.remove('is-active');
                });
            }
      });
    }
}